import { useState } from "react"

export default function SelectItem({item,lista}){
    const [open, setOpen] = useState(false);
    const eliminarLista =(idComp)=>{
       lista.splice(lista.findIndex(act=>act.idComp===idComp),1)
    }
    /*item.map((p)=>{
        console.log(p.item)
    })*/
    //console.log(item)
    if(item.childrens){
        const add = async (codigo,nivel,id,idComp,catId,piso) =>{
            if(document.getElementById(`cb${idComp}`).checked){
                if(nivel===1){
                    lista.push({id:id,idComp:idComp,codigo:codigo,nivel:nivel,piso:piso})
                    item.childrens.map((p)=>{
                        //NIVEL 2
                        if(p.childrens){
                            const existAct4 = lista.filter(dato => dato.idComp  === p.idComp);
                            if(existAct4.length===0){
                                return(
                                    (p.estado===0?(document.getElementById(`cb${p.idComp}`).checked = true,
                                    lista.push({id:p.id,idComp:p.idComp,codigo:p.codigo,nivel:p.nivel,catId:p.catId,piso:p.piso
                                    })):(null)
                                    ),p.childrens.map(m=>{
                                        const existAct3 = lista.filter(dato => dato.idComp  === m.idComp);
                                        if(existAct3.length===0){
                                            return ( m.estado===0?(  document.getElementById(`cb${m.idComp}`).checked = true,
                                            lista.push({id:m.id,idComp:m.idComp,codigo:m.codigo,nivel:m.nivel,catId:m.catId,piso:m.piso
                                            })):(null))
                                        } 
                                        return null;
                                    })
                                )    
                            }
                            //NIVEL 3
                        }else{
                            const existAct = lista.filter(dato => dato.idComp  === p.idComp);
                            if(existAct.length===0){
                                return(
                                    (p.estado===0?(document.getElementById(`cb${p.idComp}`).checked = true,
                                    lista.push({id:p.id,codigo:p.codigo,idComp:p.idComp,nivel:p.nivel,catId:p.catId,piso:p.piso
                                    })):(null) )                                
                                )
                            }
                        }
                        return null;
                    })
                } else if(nivel===2){
                    lista.push({id:id,idComp:idComp,codigo:codigo,nivel:nivel,catId:catId,piso:piso})
                    //NIVEL 3
                    item.childrens.map(p =>{ 
                        const existAct2 = lista.filter(dato => dato.idComp  === p.idComp);
                        if(existAct2.length===0){
                            return(
                                (p.estado===0?(document.getElementById(`cb${p.idComp}`).checked = true,
                                lista.push({id:p.id,idComp:p.idComp,codigo:p.codigo,nivel:p.nivel,catId:p.catId,piso:p.piso
                                })):(null))                                
                            )
                        }
                        return null;
                    })
                }
            }else{
                eliminarLista(idComp);
                if(nivel===1){
                    item.childrens.map(p =>{
                        //NIVEL 2
                        if(p.childrens){
                            p.childrens.map(m=>{
                                //NIVEL 3
                                return (document.getElementById(`cb${m.idComp}`).checked = false,
                                eliminarLista(m.idComp)
                                )
                            })
                            return(
                                (document.getElementById(`cb${p.idComp}`).checked = false,
                                eliminarLista(p.idComp))
                            )
                        }else{
                            return(
                                (document.getElementById(`cb${p.idComp}`).checked = false,
                                eliminarLista(p.idComp))                                
                            )
                        }
                    })
                } else if(nivel===2){
                    item.childrens.map(p =>{ 
                        return(
                            //NIVEL 3
                            (document.getElementById(`cb${p.idComp}`).checked = false,
                            eliminarLista(p.idComp))                                
                        )
                    })
                }
            }
        }

        return (
            //PRIMER NIVEL
            <div className={open ? "sidebar-item open" : "sidebar-item"}>
                <div className="sidebar-title">
                    <span>
                        <input type="checkbox" id={`cb${item.idComp}`} 
                            defaultChecked={item.estado===1?true:false} 
                            disabled={item.estado===1?true:false} 
                            onClick={()=>add(
                            item.codigo,item.nivel,item.id,item.idComp,item.catId,item.piso
                            )}  style={{marginRight:"10px"}}
                        />
                        {item.title}
                    </span> 
                    <i className="bi-chevron-down toggle-btn" onClick={() => setOpen(!open)}></i>
                </div>
                <div className="sidebar-content">
                    { item.childrens.map((child, index) => <SelectItem key={index} item={child} lista={lista} index={null}/> ) }
                </div>
            </div>
        )
    }else{
        const addNivelF = async (codigo,nivel,id,idComp,catId,piso) =>{
            if(document.getElementById(`cb${idComp}`).checked){
                if(nivel===1){
                    return(
                        (document.getElementById(`cb${idComp}`).checked = true,lista.push({id:id,idComp:idComp,codigo:codigo,nivel:nivel,piso:piso
                        }),console.log(lista))   
                    )
                } else{
                   /* const existAct = lista.filter(dato => dato.idComp  === idComp);
                    if(existAct.length===0){
                        return(
                            (document.getElementById(`cb${idComp}`).checked = true,lista.push({id:id,idComp:idComp,codigo:codigo,nivel:nivel,catId:catId,piso:piso
                            }),console.log(lista))
                        )
                    } */
                    return(
                        (document.getElementById(`cb${idComp}`).checked = true,lista.push({id:id,idComp:idComp,codigo:codigo,nivel:nivel,catId:catId,piso:piso
                        }),console.log(lista))
                    )
                }
            }else{
                return(
                    (document.getElementById(`cb${idComp}`).checked = false,
                    eliminarLista(idComp),console.log(lista))   
                )
            }
        }
        return (
            //primer nivel
            <div className="sidebar-item plain" >
                <input type="checkbox" id={`cb${item.idComp}`} 
                    defaultChecked={item.estado===1?true:false} 
                    disabled={item.estado===1?true:false}
                    onClick={()=>addNivelF(
                    item.codigo,item.nivel,item.id,item.idComp,item.catId,item.piso
                    )}
                    style={{marginRight:"10px"}}
                />
                {item.title} 
            </div>
        )
    }       
    /*if(item.childrens){
        const add = async (codigo,nivel,id,catId) =>{
            if(document.getElementById(`cb${codigo}`).checked){
                if(nivel===1){
                    lista.push({id:id,codigo:codigo,nivel:nivel
                    })
                    item.childrens.map((p)=>{
                        //NIVEL 2
                        console.log(p)
                        if(p.childrens){
                            //NIVEL 3
                                p.childrens.map(m=>{
                                    console.log(m)
                                    return ( m.estado===0?(  document.getElementById(`cb${m.codigo}`).checked = true,
                                    lista.push({id:m.id,codigo:m.codigo,nivel:m.nivel,catId:m.catId,
                                })):(null))
                                })
                                return(
                                    (p.estado===0?(document.getElementById(`cb${p.codigo}`).checked = true,
                                    lista.push({id:p.id,codigo:p.codigo,nivel:p.nivel,catId:p.catId
                                    })):(null)
                                    )
                                    )
                        }else{
                            return(
                                (p.estado===0?(document.getElementById(`cb${p.codigo}`).checked = true,
                                lista.push({id:p.id,codigo:p.codigo,nivel:p.nivel,catId:p.catId
                                })):(null) )                                
                            )
                        }
                    })

                    console.log(lista)

                } else if(nivel===2){
                    lista.push({id:id,codigo:codigo,nivel:nivel,catId:catId
                    })
                    //NIVEL 3
                    item.childrens.map(p =>{ 
                        //console.log(p)
                            return(
                                (p.estado===0?(document.getElementById(`cb${p.codigo}`).checked = true,
                                lista.push({id:p.id,codigo:p.codigo,nivel:p.nivel,catId:p.catId
                                })):(null))                                
                            )
                    })
                    console.log(lista)
                }
            }else{
                eliminarLista(codigo);
                if(nivel===1){
                    item.childrens.map(p =>{
                        //NIVEL 2
                        if(p.childrens){
                            p.childrens.map(m=>{
                                //NIVEL 3
                                return (document.getElementById(`cb${m.codigo}`).checked = false,
                                eliminarLista(m.codigo)
                                )
                            })
                                    return(
                                        (document.getElementById(`cb${p.codigo}`).checked = false,
                                        eliminarLista(p.codigo))
                                    )
                        }else{
                            return(
                                (document.getElementById(`cb${p.codigo}`).checked = false,
                                eliminarLista(p.codigo))                                
                            )
                        }
                    })

                    console.log(lista)

                } else if(nivel===2){
                    item.childrens.map(p =>{ 
                        console.log(p)
                            return(
                                //NIVEL 3
                                (document.getElementById(`cb${p.codigo}`).checked = false,
                                eliminarLista(p.codigo))                                
                            )
                    })
                    console.log(lista)
                }
            }
        }

        return (
            //PRIMER NIVEL
                <div className={open ? "sidebar-item open" : "sidebar-item"}>
                <div className="sidebar-title">
                    <span>
                            <input type="checkbox" id={`cb${item.codigo}`} 
                            defaultChecked={item.estado===1?true:false} 
                            disabled={item.estado===1?true:false} 
                                onClick={()=>add(
                                item.codigo,item.nivel,item.id,item.catId
                                )}  style={{marginRight:"10px"}}
                                />
                        {item.title}
                    </span> 
                    <i className="bi-chevron-down toggle-btn" onClick={() => setOpen(!open)}></i>
                </div>
                <div className="sidebar-content">
                    { item.childrens.map((child, index) => <SelectItem key={index} item={child} lista={lista}/> ) }
                </div>
            </div>

        )
    }else{
        const addNivelF = async (codigo,nivel,id,catId) =>{
            if(document.getElementById(`cb${codigo}`).checked){
                if(nivel===1){
                            return(
                                (document.getElementById(`cb${codigo}`).checked = true,lista.push({id:id,codigo:codigo,nivel:nivel
                                }),console.log(lista))   
                            )

                } else{
                            return(
                                (document.getElementById(`cb${codigo}`).checked = true,lista.push({id:id,codigo:codigo,nivel:nivel,catId:catId
                                }),console.log(lista))
                            )
                }
            }else{
                                return(
                                    (document.getElementById(`cb${codigo}`).checked = false,
                                    eliminarLista(codigo),console.log(lista))   
                                )
                    } 
            
        }
        return (
            //primer nivel
            <div className="sidebar-item plain" >
                <input type="checkbox" id={`cb${item.codigo}`} 
                defaultChecked={item.estado===1?true:false} 
                disabled={item.estado===1?true:false}
                                onClick={()=>addNivelF(
                               item.codigo,item.nivel,item.id,item.catId
                               
                                )}
                 style={{marginRight:"10px"}}/>
                {item.title} 
            </div>
        )
    }*/
}